var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',_vm._g({staticClass:"checkbox mt-0 pt-0",attrs:{"hide-details":_vm.hideDetails,"ripple":_vm.ripple,"label":_vm.label},scopedSlots:_vm._u([{key:"label",fn:function(){return undefined},proxy:true}]),model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }